import useCommonCartQuery from "@repo/shopify/queries/useCartQuery";

import useLanguage from "@hooks/useLanguage";
import useSessionExpired from "@hooks/useSessionExpired";

import { useCartStore } from "@store/cart";
import { useCustomerStore } from "@store/customer";
import { useLayoutStore } from "@store/layout";

export default function useCart() {
  const onSessionExpired = useSessionExpired();

  const { lang } = useLanguage();
  const { cart, updateCart } = useCartStore();
  const { openToast } = useLayoutStore();
  const { customer, token } = useCustomerStore();

  return useCommonCartQuery({
    lang,
    cart,
    updateCart,
    customer,
    accessToken: token.accessToken,
    openToast,
    onSessionExpired,
  });
}
